import { axiosCompanyPortalInstance } from "./";

const updateApplicantDeduction = async ({ id, event_id, params }) =>
  await axiosCompanyPortalInstance.post(
    `/events/${+event_id}/users/${id}/add_manual_deduction`,
    params
  );

const updateApplicantReward = async ({ id, event_id, params }) =>
  await axiosCompanyPortalInstance.post(
    `/events/${+event_id}/users/${id}/add_reward`,
    params
  );

const updateApplicantRevertReward = async ({ id, event_id }) =>
  await axiosCompanyPortalInstance.patch(
    `/events/${+event_id}/users/${id}/revert_reward`
  );

const updateApplicantRevertDeduction = async ({ id, event_id }) =>
  await axiosCompanyPortalInstance.patch(
    `/events/${+event_id}/users/${id}/revert_manual_deduction`
  );

const BULK_STATUS_VALIDATE = (status) =>
  (status >= 200 && status < 300) || status === 207;

const getLoyalApplicants = (params = {}, config = {}) =>
  axiosCompanyPortalInstance.get("/users", { ...config, params });

const bulkRemoveLoyalApplicants = (data) =>
  axiosCompanyPortalInstance.post("/users/bulk_remove_loyalty", data, {
    validateStatus: BULK_STATUS_VALIDATE,
  });

const getApplicantProfile = (id, config = {}) =>
  axiosCompanyPortalInstance.get(`/users/${id}`, config);

export {
  getLoyalApplicants,
  bulkRemoveLoyalApplicants,
  getApplicantProfile,
  updateApplicantDeduction,
  updateApplicantReward,
  updateApplicantRevertReward,
  updateApplicantRevertDeduction,
};
